/// <amd-module name="VSS/Features/PlatformUI/ContributedIcon" />
export { ContributedIcon, contributedIconToIconProps } from "./Components/ContributedIcon/ContributedIcon";
export { IContributedIconProps } from "./Components/ContributedIcon/ContributedIcon.Props";
